/* eslint-disable no-debugger */
import { isValidDate, isValidBirthDate, isValidNumber, isValidSwimTime } from '@usas/ui-web/utils/validation';
import Constants from '@usas/ui-web/utils/Constants';
import { formatTimeForDisplay, formatTimeForFilterObject } from '@usas/ui-web/utils/TimesUtils';

export const localValidate = (formState) => {
  const errors = {};

  if (formState.eventName === ''
    || formState.eventId === Constants.DEFAULT_ID) {
    errors.eventId = 'Event is required';
  }

  if (formState.swimDate === Constants.BLANK_DATE_STRING) {
    errors.swimDate = 'Swim Date is required';
  } else if (!isValidDate(formState.swimDate)) {
    errors.swimDate = 'Swim Date must be a valid date'
  } else if (!isValidBirthDate(formState.swimDate)) {
    errors.swimDate = 'Swim Date cannot be in the future'
  }

  const meetStartDate = new Date(formState.meetStartDate);
  const meetEndDate = new Date(formState.meetEndDate);
  const swimDate = new Date(formState.swimDate);

  if (swimDate < meetStartDate || swimDate > meetEndDate) {
    errors.swimDate = 'Swim Date must be between the Meet Start Date and the Meet End Date'
  }

  if (formState.place !== '' && (!isValidNumber(formState.place) || formState.place === '0')) {
    errors.place = 'Place must be a number greater than zero if entered'
  }

  if (formState.entryTime !== '') {
    if (!isValidSwimTime(formatTimeForFilterObject(formatTimeForDisplay(formState.entryTimeValue)))) {
      errors.entryTime = 'Entry Time must be a valid time';
    }
  }

  if (formState.swimTime === '' || formState.swimTime === 'NT') {
    errors.swimTime = 'Swim Time is required';
  } else if (!isValidSwimTime(formatTimeForFilterObject(formatTimeForDisplay(formState.swimTimeValue)))) {
    errors.swimTime = 'Swim Time must be a valid time';
  }

  //Event Number
  if (formState.eventNumber !== '' && (!isValidNumber(formState.eventNumber.trim()) || formState.eventNumber.trim() === '0')) {
    errors.eventNumber = 'Event Number must be a number greater than zero if entered';
  }

  if (formState.eventNumber !== '' && parseInt(formState.eventNumber.trim()) > 999) {
    errors.eventNumber = 'Event Number cannot be greater than 999 if entered';
  }

  //Event Age Minimum/Maximum
  if (
      formState.eventAgeMin !== '' && 
      (!isValidNumber(formState.eventAgeMin.trim()) || formState.eventAgeMin.trim() === '0')) {
    errors.eventAgeMin = 'Event Age Minimum must be a number greater than zero if entered';
  }

  if (formState.eventAgeMin !== '' && formState.eventAgeMax !== '' && parseInt(formState.eventAgeMin.trim()) > parseInt(formState.eventAgeMax.trim())) {
    errors.eventAgeMin = 'Event Age Minimum cannot be greater than Event Age Maximum';
  }

  if (formState.eventAgeMax !== '' && parseInt(formState.eventAgeMax.trim()) > 99) {
    errors.eventAgeMax = 'Event Age Maximum cannot be greater than 99 if entered';
  }

  if (formState.eventAgeMax !== '' && (!isValidNumber(formState.eventAgeMax.trim()) || formState.eventAgeMax.trim() === '0')) {
    errors.eventAgeMax = 'Event Age Maximum must be a number greater than zero if entered';
  }

  if (formState.eventAgeMin !== '' && formState.eventAgeMax === '') {
    errors.eventAgeMax = 'Event Age Maximum is required if Event Age Minimum is entered';
  }

  if (formState.eventAgeMax !== '' && formState.eventAgeMin === '') {
    errors.eventAgeMin = 'Event Age Minimum is required if Event Age Maximum is entered';
  }

  //Session
  if (formState.sessionId === Constants.DEFAULT_ID) {
    errors.sessionId = 'Session is required';
  }

  return errors;
};

const TimeDetailsValidation = async (formState) => {
  let errors = localValidate(formState);

  return errors ? errors : {};
};

export default TimeDetailsValidation;